/**
 * Node 전역 `process.nextTick` 대체 — 화상통화가 쓰는 simple-peer(readable-stream 3)가 부른다.
 *
 * ⚠ src/index.tsx의 **첫 import**여야 한다. 지우거나 순서를 바꾸면 통화가 연결되지 않는다.
 *   CRA 5(webpack 5)는 Node 전역을 넣어 주지 않아 브라우저·WebView2에는 `process`가 없다. simple-peer는 readable-stream
 *   Duplex라 `peer.on('data')`가 동기로 `process.nextTick`을 부르는데, 그게 ReferenceError로 callService.setupPeerEvents를
 *   중단시켜 피어가 등록되지 않고 answer도 나가지 않았다(2026-11-03 PC 앱 2.1.2 — 모든 통화의 영상·소리·화면 공유가 끊김).
 *   통화 종료의 `peer.destroy()`도 같은 이유로 중간에 멈춰 RTCPeerConnection이 닫히지 않았다.
 * ⚠ import 금지: scripts/test-process-shim.js가 typescript.transpileModule로 통째로 평가한다.
 *
 * 이미 `process`가 있으면(Node·테스트) 건드리지 않는다. 번들의 다른 `process` 참조는 debug의 환경 검사뿐이라
 * (`typeof process`·`window.process.type`) 이 객체가 생겨도 결과가 바뀌지 않는다.
 */

type TickFn = (...args: unknown[]) => void;

/** @returns 새로 설치했으면 true */
export function installProcessShim(g: any): boolean {
  if (!g) return false;
  const defer: (cb: () => void) => void = typeof g.queueMicrotask === 'function'
    ? (cb) => g.queueMicrotask(cb)
    : (cb) => { Promise.resolve().then(cb); };
  const nextTick = (fn: TickFn, ...args: unknown[]) => defer(() => fn(...args));

  if (g.process === undefined || g.process === null) {
    g.process = { browser: true, env: {}, nextTick };
    return true;
  }
  if (typeof g.process.nextTick !== 'function') {
    g.process.nextTick = nextTick;
    return true;
  }
  return false;
}

installProcessShim(typeof globalThis !== 'undefined' ? globalThis : undefined);
